import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('PriceGroupFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getNewPriceGroup: function () {
            return $http.get(settings.ApiURL + settings.PriceGroupURL + "/products/newpricegroup");
        },
        getPriceGroupList: function () {
            return $http.get(settings.ApiURL + settings.PriceGroupURL + '/products');
        },
        getProducts: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + '/dropdown/1');
        },
        getProductDetails: function (id) {
            return $http.get(settings.ApiURL + settings.ProductURL + '/' + id);
        },
        getSystemPreferences: function () {
            return $http.get(settings.ApiURL + settings.ConfigurationURL + '/systempreferences');
        },        
        getPriceGroupById: function (id) {
            return $http.get(settings.ApiURL + settings.PriceGroupURL + '/products/' + id);
        },
        savePriceGroup: function (priceGroup) {
            return $http.put(settings.ApiURL + settings.PriceGroupURL + '/products', priceGroup);
        },
        deletePriceGroup: function (id) {
            return $http.delete(settings.ApiURL + settings.PriceGroupURL + '/products/' + id);
        }
    };
}]);

app.controller('PriceGroupController', function ($q, $scope, PriceGroupFactory, $rootScope, settings, masterFactory, $filter) {
    $rootScope.pageTitle = "Price Group";       
    $scope.priceGroups = [];
    $scope.priceGroup = {};
    $scope.newpriceGroup = {};
    $scope.products = [];
    $scope.moneySign = '';
    $scope.selectedPriceGroup = -1
    $scope.error = "";
    $scope.modelState = [];
    $scope.isFormVisible = false;
    $scope.pageSize = 20;

    // Initialization - this runs on load
    var init = function () {
        masterFactory.verifyAuthentication();
        

        $q.all([
            PriceGroupFactory.getSystemPreferences().success(function (data) {
                $scope.moneySign = data.CurrencyString;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            $('#loadingModal').modal({ backdrop: 'static' }),
            PriceGroupFactory.getPriceGroupList().success(function (data) {
                $scope.priceGroups = data;
                PriceGroupFactory.getProducts().success(function (data) {
                    $scope.products = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
                $scope.refreshGrid(0);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            }),
            PriceGroupFactory.getNewPriceGroup().success(function (data) {
                $scope.newpriceGroup = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            })
        ]).then(function () {
        });

        
        
    };

    init();

    // Grid renderers
    $scope.refreshGrid = function (PageIndex) {
        $('#gridPriceGroup').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.priceGroups,
                    type: 'array',
                    key: 'Id'
                }
            },
            noDataText: "No Price Groups Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            contentReadyAction: grdReadyAction,
            selection: { mode: 'single' },
            paging: {
                pageSize: $scope.pageSize,
                pageIndex: PageIndex
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: true
            },
            groupPanel: {
                visible: false,
            },
            columns: [
                {
                    caption: 'Price Group ID',
                    dataField: 'Id',
                    cssClass: 'Id',
                    dataType: 'number',
                    alignment: 'center'
                },
                {
                    caption: 'Products in the Group',
                    dataField: 'NumberOfProducts',
                    cssClass: 'NumberOfProducts',
                    dataType: 'number',
                    alignment: 'center'
                }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $('#loadingModal').modal({ backdrop: 'static' });
                    PriceGroupFactory.getPriceGroupById(selectedRowsInfo.selectedRowsData[0].Id).success(function (data) {
                        $scope.priceGroup = data;
                        $scope.isFormVisible = true;
                        $scope.isDeleteVisible = true;
                        ToggleYellowToGreen();
                        $rootScope.pageTitle = "Price Groups";
                        $scope.refreshPriceGroupProducts();
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#loadingModal').modal('hide');
                    });
                }
            }

        });
    };

    $scope.refreshPriceGroupProducts = function () {

        $('#gridPriceGroupProducts').dxDataGrid({
            dataSource: $scope.priceGroup.Products,
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            height: 470,
            selection: { mode: 'single' },
            paging: {
                pageSize: 30
            },
            editing: {
                editEnabled: false,
                insertEnabled: true,
                removeEnabled: true
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: false
            },
            groupPanel: {
                visible: false,
            },
            columns: [
                {
                    caption: 'Product',
                    dataField: 'ProductId',                    
                    validationRules: [{ type: 'required' }],
                    alignment: 'center',
                    width: '40%',
                    lookup: {
                        dataSource: $scope.products,
                        displayExpr: 'ProductName',                        
                        valueExpr: 'Id'
                    }                    
                },
                {
                    caption: 'Quantity',
                    dataField: 'MinimumQty',
                    dataType: 'number',
                    validationRules: [{ type: 'required' }],
                    width: '15%',
                    alignment: 'center',
                    cellTemplate: function (container, options) {
                        var text = '> ' + (IsUndefinedOrNull(options.data.MinimumQty) ? '' : options.data.MinimumQty) + ' '
                                        + (IsUndefinedOrNull(options.data.QuantityUnit) ? '' : options.data.QuantityUnit);
                        $('<span />').text(text).appendTo(container);
                    }
                },
                {
                    caption: 'Price',
                    dataField: 'Price',
                    dataType: 'number',
                    validationRules: [{ type: 'required' }],
                    width: '15%',
                    alignment: 'center',
                    cellTemplate: function (container, options) {
                        var text = options.data.Price + ' '
                                    + (IsUndefinedOrNull($scope.moneySign) ? '' : $scope.moneySign) + '/'
                                    + ((IsUndefinedOrNull(options.data.PricePer) || (options.data.PricePer == 1)) ? '' : options.data.PricePer) + ' '
                                    + (IsUndefinedOrNull(options.data.QuantityUnit) ? '' : options.data.QuantityUnit);

                        $('<span />').text(text).appendTo(container);
                    },
                },
                {
                    caption: 'From',
                    dataField: 'FromDate',                    
                    dataType: 'date',
                    format: 'dd/MM/yyyy',
                    width: '15%',
                    alignment: 'center'
                },
                {
                    caption: 'Until',
                    dataField: 'ToDate',                    
                    dataType: 'date',
                    format: 'dd/MM/yyyy',
                    width: '15%',
                    alignment: 'center'
                }
            ],
            rowInserted: function (rowInfo) {
                var obj = rowInfo;
                PriceGroupFactory.getProductDetails(rowInfo.data.ProductId).success(function (data) {                                  
                    var filteredProducts = $filter('filter')($scope.priceGroup.Products, { ProductId: data.Id });
                    for (var i = 0; i < filteredProducts.length; i++) {
                        if (filteredProducts[i].ProductId == data.Id && IsUndefinedOrNull(filteredProducts[i].QuantityUnit)) {                          
                            filteredProducts[i].QuantityUnit = data.QuantityUnit;
                        }
                        if (filteredProducts[i].ProductId == data.Id && IsUndefinedOrNull(filteredProducts[i].PricePer)) {
                            filteredProducts[i].PricePer = data.PricePer;
                        }
                    }
                    $scope.refreshPriceGroupProducts();                 
                  
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                })               
            }
        }).dxDataGrid('instance');

        var grd = document.getElementById("gridPriceGroupProducts");
        if (grd.getElementsByClassName("dx-datagrid-header-panel")[0].childNodes.length == 1)
            $('<span > Price Group Products </span>').appendTo(grd.getElementsByClassName("dx-datagrid-header-panel")[0]);
    };

    // Button click functions and submit form function
    $scope.addNewEntity = function () {
        $rootScope.pageTitle = "New Price Group";        
        $scope.isFormVisible = true;
        $scope.isDeleteVisible = false;
        $scope.priceGroup = angular.copy($scope.newpriceGroup);
        $scope.refreshPriceGroupProducts();
        $scope.refreshPriceGroupProducts();
        ToggleGreenToYellow();
    };

    $scope.confirmDeleteEntity = function () {
        $('#DeleteModal').modal({ backdrop: 'static' });
    };

    $scope.deleteEntity = function (value) {
        if (value == 0) {
            $('#DeleteModal').modal('hide');
        }
        else if (value == 1) {
            PriceGroupFactory.deletePriceGroup($scope.priceGroup.Id).success(function (data) {
                PriceGroupFactory.getPriceGroupList($rootScope.accessToken).success(function (data) {
                    var dataGrid = $('#gridPriceGroup').dxDataGrid('instance');
                    var pageIndex = dataGrid.pageIndex();
                    $scope.pageSize = dataGrid.pageSize();
                    $scope.priceGroups = data;
                    $scope.cancelForm();
                    $scope.refreshGrid(pageIndex);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Price Group successfully' });
                });                
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#DeleteModal').modal('hide');
            });
        }
    };

    $scope.cancelForm = function () {
        var dataGrid = $('#gridPriceGroup').dxDataGrid('instance');
        dataGrid.clearSelection();
        $scope.priceGroup = {};
        $scope.priceGroup.Products = [];        
        $scope.isFormVisible = false;        
        $scope.priceGroupForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
    };

    $scope.reset = function (type) {
        if (type == 'update') { // get db bankaccount and set to scope.bankaccount.
            PriceGroupFactory.getPriceGroupById($scope.priceGroup.Id).success(function (data) {
                $scope.priceGroup = data;
                $scope.refreshPriceGroupProducts();
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        }
        else {
            angular.copy($scope.newpriceGroup, $scope.priceGroup);
            $scope.refreshPriceGroupProducts();
        }
        $scope.priceGroupForm.$setPristine();
        $scope.priceGroupForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Price Group details were reset' });        
    };

    $scope.submitForm = function () {
        if ($scope.priceGroupForm.$valid) {
            $scope.savePriceGroup();
            $scope.priceGroupForm.submitted = false;
        } else {
            $scope.priceGroupForm.submitted = true;
        }
    };

    $scope.savePriceGroup = function () {
        if (IsUndefinedOrNull($scope.priceGroup.Id) || $scope.priceGroup.Id <= 0) {
            $scope.priceGroup.Id = -1;
        }
        if ($scope.priceGroup.Products.length > 0) {
            $('#loadingModal').modal({ backdrop: 'static' });
            PriceGroupFactory.savePriceGroup($scope.priceGroup).success(function (data) {
                PriceGroupFactory.getPriceGroupList($rootScope.accessToken).success(function (data) {
                    var dataGrid = $('#gridPriceGroup').dxDataGrid('instance');
                    var pageIndex = dataGrid.pageIndex();
                    $scope.pageSize = dataGrid.pageSize();
                    $scope.priceGroups = data;
                    if ($scope.priceGroup.Id > 0) {
                        $scope.refreshGrid(pageIndex)
                    }
                    else {
                        $scope.cancelForm();
                        $scope.refreshGrid(pageIndex);
                    }
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    if ($scope.priceGroup.Id > 0) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Price Group successfully' });
                    }
                    else {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Price Group successfully' });
                    }                    
                });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        }
        else {
            $scope.error = 'Add minimum one Product!';
        }
    }

    // Helping functions and events
    $(window).resize(function () {
        onWindowResize('#gridPriceGroup', settings.GridMarginHeight);
    });

    function grdReadyAction(e) {
        onWindowResize('#gridPriceGroup', settings.GridMarginHeight);
    };

    collapsibleHeaderClickEvent($scope);

    $scope.closeAlert = function () {
        $scope.error = null;
    };

    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    $scope.filter = function (input, id) {
        var i = 0, len = input.length;
        for (; i < len; i++) {
            if (+input[i].Id == +id) {
                return input[i];
            }
        }
        return null;
    };

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };

    //var quantityUnitExits = function (quantityUnit) {
    //    var flag = false;
    //    $scope.factorQuantityUnits.forEach(function (qUnit) {
    //        if (qUnit.name == quantityUnit) {
    //            flag = true;
    //        }
    //    });
    //    return flag;
    //};

});